// The three export buttons under a table are the only reason this application
// needs SheetJS, jsPDF or PapaParse at all, and an export is a deliberate act:
// nobody downloads one by opening a page. Fetching them here, on the click,
// keeps the better part of a megabyte of spreadsheet parser and PDF engine out
// of the bundle every visitor loads - including the anonymous visitor who
// never signs in and never sees a table.
//
// The promise is kept rather than the modules, so a second export costs
// nothing and two buttons pressed at once share one fetch.
let pending = null;

const loadExportLibraries = () => {
  if (!pending) {
    pending = Promise.all([
      import("papaparse"),
      import("xlsx"),
      // jspdf-autotable puts autoTable onto jsPDF's prototype as a side
      // effect, so it has to have finished loading - not merely been asked
      // for - before the first doc.autoTable() call.
      import("jspdf").then((jspdf) =>
        import("jspdf-autotable").then(() => jspdf)
      ),
    ]).then(([papa, xlsx, jspdf]) => ({
      Papa: papa.default || papa,
      XLSX: xlsx.default || xlsx,
      JsPDF: jspdf.default || jspdf,
    }));
  }
  return pending;
};

export default loadExportLibraries;
